import { render } from "./HumanBodyMapWithSingleRole.vue?vue&type=template&id=228fbe0f&ts=true"
import script from "./HumanBodyMapWithSingleRole.vue?vue&type=script&lang=ts"
export * from "./HumanBodyMapWithSingleRole.vue?vue&type=script&lang=ts"

import "./HumanBodyMapWithSingleRole.vue?vue&type=style&index=0&id=228fbe0f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Surveys/utils/HumanBodyMapWithSingleRole.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "228fbe0f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('228fbe0f', __exports__)) {
    api.reload('228fbe0f', __exports__)
  }
  
  module.hot.accept("./HumanBodyMapWithSingleRole.vue?vue&type=template&id=228fbe0f&ts=true", () => {
    api.rerender('228fbe0f', render)
  })

}


export default __exports__